// 封装
import axiosService from "./axios-request"; /* 从axios-request.js内引入axiosService */

/* 下面是POST形式 */
// method支持字符创小写形式："get"、"post"、"put"
// params是键值对的json对象
export const httpRequest = (url, method, params, config = {}) => {
  if (method === "get") {
    return axiosService({
      url,
      method,
      params,
      ...config
    });
  } else {
    return axiosService({
      url,
      method,
      data: params,
      ...config
    });
  }
};
